<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Chapter-Number" id="_idParaDest-3"><span class="CharOverride-1"><a id="_idTextAnchor003"></a>Dedication</span></p>
<p class="Basic-Paragraph ParaOverride-3"><br/>
<br/>
<br/>
    For my buddy Gary. Thank you for your deep friendship, encouragement, and support over the past four decades.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816115330882.vue?62786d80